module.exports = __webpack_public_path__ + "static/img/trainTicket.641efc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/trainTicket.png
// module id = 4vZU
// module chunks = 1